// extracted by mini-css-extract-plugin
module.exports = {"loyaltyProgramWrapper":"styles_loyaltyProgramWrapper__3JFHt","loyaltyProgramHeader":"styles_loyaltyProgramHeader__2td21"};